module.exports = __webpack_public_path__ + "static/media/help_register_business.4bc0cf68.jpg";